import { type RowData, type TableOptions, useReactTable } from './tanstack.js';
import type { TableEngine } from './types.js';

/** Creates a data engine using TanStack Table. */
export function useTableEngine<TData extends RowData>(options: TableOptions<TData>): TableEngine<TData> {
  const tableOptions: TableOptions<TData> = {
    // Disable all features supported by Cimpress UI.
    // This way consumers have to opt-in to every feature,
    // which will prevent existing tables from breaking when new features are added to Cimpress UI.
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableSorting: false,
    enableSortingRemoval: false,
    enableMultiSort: false,
    enableHiding: false,
    ...options,
  };

  if (tableOptions.manualPagination && typeof tableOptions.rowCount !== 'number') {
    tableOptions.rowCount = tableOptions.cimpressUi?.totalRowCount;
  }

  return useReactTable(tableOptions);
}
